import { Box } from "@mui/material";
import ChatHeader from "./ChatHeader";
import ChatInput from "./ChatInput";

const ChatSidebar = ({
  isSmallScreen,
  title,
  subtitle,
  isProcessing,
  showSendLoading,
  onSendMessage,
  onToggleSidebar,
  scrollRef,
  headerExtra,
  hideInput = false,
  children,
}) => {
  return (
    <Box
      sx={{
        width: { xs: "100%", sm: 420 },
        maxWidth: { xs: "100%", sm: 420 },
        height: "100%",
        bgcolor: "background.paper",
        borderRight: { xs: 0, sm: "1px solid rgba(0, 0, 0, 0.12)" },
        display: "flex",
        flexDirection: "column",
        position: "relative",
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      <ChatHeader
        isSmallScreen={isSmallScreen}
        title={title}
        subtitle={subtitle}
        onClose={onToggleSidebar}
      />

      {headerExtra}

      <Box
        ref={scrollRef}
        sx={{
          flex: 1,
          overflowY: hideInput ? "hidden" : "auto",
          display: "flex",
          flexDirection: "column",
          gap: hideInput ? 0 : 2,
          px: hideInput ? 0 : 2,
          py: hideInput ? 0 : 2,
          minHeight: 0,
        }}
      >
        {children}
      </Box>

      {hideInput ? null : (
        <ChatInput
          onSend={onSendMessage}
          isProcessing={isProcessing}
          showSendLoading={showSendLoading}
        />
      )}
    </Box>
  );
};

export default ChatSidebar;
